import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import { AuthService } from '../services/common/auth.service'
import { Store } from '@ngrx/store'
import { DynamicComponentLoaderService } from '../services/component-loader/dynamic-component-loader.service'
import { AppState } from '../store/state/app.state'
import { ResetPasswordComponent } from '../components/reset-password/reset-password.component'
import { GlobalConstants } from '../constants/global-constants'
import { AuthType } from '../models/model'

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private appState: Store<AppState>,
    private dynamicComponentLoaderService: DynamicComponentLoaderService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isUserAuthenticated = this.authService.isUserAuthenticated()
    if (!isUserAuthenticated) {
      this.authService.redirectToLogin()
      return false
    } else {
      this.appState
        .select((state) => state.initialize)
        .subscribe(({ user, authType }) => {
          if (user?.passwordAutoGenerated && AuthType.PASSWORD === authType) {
            this.dynamicComponentLoaderService.loadComponent(GlobalConstants.DYNAMIC_MODEL.RESET_PASSWORD.key)
          }
        })
    }
    return true
  }
}
